import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { Button, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getResponsables } from "../../../../redux/actions/empleador";
import { StyledResponsablesCard } from "../../../styled/Responsables";
import FormikAutocomplete from "../../formik/FormikAutocomplete";

const ResponsablesCard = ({ name, responsableType = null, title, handleOpenAddResponsable, required, fieldLabel, variant = "default" }) => {
  const dispatch = useDispatch();
  const responsables = useSelector((state) => responsableType ?
    state.empleador.responsables?.[responsableType]?.data ?? []
    : state.empleador.responsables.data
  );

  const xs = variant === "vertical" ? 10 : 11;
  return (
    <StyledResponsablesCard.Card>
      <StyledResponsablesCard.Title variant="h6">
        {title}
      </StyledResponsablesCard.Title>

      <Grid container >
        <Grid item xs={xs}>
          <FormikAutocomplete
            name={name}
            label={(fieldLabel ?? title) + (required ? " *" : "")}
            options={responsables}
            renderOption={(option) => option.nombre}
            filterOptions={(option) => option.nombre}
            getOptions={() => dispatch(getResponsables(responsableType))}
          />
        </Grid>
        <StyledResponsablesCard.IconAligned
          item
          xs={12 - xs}
        >
          <Button
            color="primary"
            variant="contained"
            onClick={() => handleOpenAddResponsable(name, responsableType)}
          >
            <StyledResponsablesCard.Icon component={PersonAddAltOutlinedIcon}/>
          </Button>
        </StyledResponsablesCard.IconAligned>
      </Grid>

    </StyledResponsablesCard.Card>
  )
}

export default ResponsablesCard;


